import {getCurrency, getTaxConfig} from '@wix/wix-events-commons-statics'
import {getEvent} from '../../../../selectors/event'
import {getOrderedTickets} from '../../../../selectors/placed-order'
import {getSeatingPlan} from '../../../../selectors/seating/plan'
import {getTickets} from '../../../../selectors/tickets'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {connect} from '../../../runtime-context/context'
import {TicketsSummaryOwnProps, TicketsSummaryRuntimeProps} from './interfaces'
import {TicketsSummary as Presentation} from './tickets-summary'

const mapRuntime = ({state}: DetailsPageAppProps): TicketsSummaryRuntimeProps => {
  const event = getEvent(state)
  const tickets = getTickets(state)

  const orderedTickets = getOrderedTickets(state, tickets)
  const taxConfig = getTaxConfig(event) as wix.events.TaxConfig

  return {
    tickets: orderedTickets,
    currency: getCurrency(event),
    taxConfig,
    seatingPlan: getSeatingPlan(state),
  }
}

export const TicketsSummary = connect<TicketsSummaryOwnProps, TicketsSummaryRuntimeProps>(mapRuntime)(Presentation)

export * from './interfaces'
